/**
 * Rollouts listed beside an authoring job. They are ordinary runs on the experiment
 * board, so each row links there rather than re-rendering nodes, steps and scores.
 */
import { Link } from 'react-router-dom'
import { Icon } from '@/components/Icon'
import { fmtAgo } from '@/lib/format'
import type { TaskExperiment } from './types'

export function ExperimentRows({ experiments, empty }: { experiments: TaskExperiment[]; empty: string }) {
  if (!experiments.length) return <p className="empty">{empty}</p>
  return <div className="rows">{experiments.map(run => {
    const c = run.configuration || {}
    const score = run.metrics?.mean_verifier_score
    return <Link key={run.run_id} className="trow" to={`/eng/runs/${run.run_id}`}>
      <div>
        <div className="title experiment-model-title">{run.origin === 'agent' && <Icon name="agent" size={20} />}<span>{String(c.model ?? 'unknown model')}</span></div>
        <div className="subline">
          {[c.harness, c.sampler].filter(Boolean).join(' · ') || 'no harness recorded'}
          {c.max_steps ? ` · ${c.max_steps} steps` : ''}{c.seed != null ? ` · seed ${c.seed}` : ''}
          {run.origin !== 'agent' && run.created_by_email ? ` · ${run.created_by_email.split('@')[0]}` : ''}
        </div>
      </div>
      <div className="side">
        <span className={`chip run-${run.status}`}>{run.status}</span>
        <span className="when">{score == null ? '—' : `score ${score.toFixed(2)}`}</span>
        <span className="when">{run.created_at ? fmtAgo(run.created_at) : ''}</span>
        <span className="arrow">›</span>
      </div>
    </Link>
  })}</div>
}
